import { OpcionSelect } from "@/components/input/TextInput";

export type UnidadAcademicaResponse = {
    unidadId: string
    nombre: string
    activa: boolean
    tipo: string
    codigo: string
  };

export const unidadAcademicaResponseToOpcionSelect = (unidad: UnidadAcademicaResponse): OpcionSelect => {
    return {
        valor: unidad.unidadId,
        label: unidad.nombre
    };
}
